

export function button326_mouseIn(event) {
    $w("#box44").show(); 
}

export function button326_mouseOut(event) {
    $w("#box44").hide(); 
}

export function text260_mouseIn(event) {
    $w("#box44").show(); 
}

export function text260_mouseOut(event) {
    $w("#box44").hide(); 
}

export function button334_mouseIn(event) {
    $w("#box45").show();
}

export function button334_mouseOut(event) {
    $w("#box45").hide(); 
}

export function text269_mouseIn(event) {
    $w("#box45").show(); 
}

export function text269_mouseOut(event) {
    $w("#box45").hide();
}

export function text268_mouseIn(event) {
    $w("#box45").show(); 
}

export function text268_mouseOut(event) {
    $w("#box45").hide();
}

export function button333_mouseIn(event) {
    $w("#box46").show();  
}

export function button333_mouseOut(event) {
    $w("#box46").hide(); 
}

export function text267_mouseIn(event) {
    $w("#box46").show();  
}

export function text267_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button332_mouseIn(event) {
    $w("#box47").show();
}

export function button332_mouseOut(event) {
    $w("#box47").hide();
}

export function text266_mouseIn(event) {
    $w("#box47").show(); 
}

export function text266_mouseOut(event) {
    $w("#box47").hide();
}

export function button331_mouseIn(event) {
    $w("#box48").show();  
}

export function button331_mouseOut(event) {
     $w("#box48").hide(); 
}

export function text264_mouseIn(event) {
    $w("#box48").show();  
}

export function text264_mouseOut(event) {
     $w("#box48").hide(); 
}

export function text265_mouseIn(event) {
    $w("#box48").show(); 
}

export function text265_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button330_mouseIn(event) {
    $w("#box49").show(); 
}

export function button330_mouseOut(event) {
    $w("#box49").hide();
}

export function text263_mouseIn(event) {
    $w("#box49").show(); 
}

export function text263_mouseOut(event) {
    $w("#box49").hide();
}

export function button329_mouseIn(event) {
    $w("#box50").show(); 
}

export function button329_mouseOut(event) {
    $w("#box50").hide();  
}

export function text262_mouseIn(event) {
    $w("#box50").show();  
}

export function text262_mouseOut(event) {
    $w("#box50").hide(); 
}

export function text261_mouseIn(event) {
    $w("#box50").show(); 
}

export function text261_mouseOut(event) {
    $w("#box50").hide(); 
}

export function button339_mouseIn(event) {
    $w("#box44").show(); 
}

export function button339_mouseOut(event) {
    $w("#box44").hide();  
}

export function button338_mouseIn(event) {
    $w("#box44").show(); 
}

export function button338_mouseOut(event) {
    $w("#box44").hide();  
}

export function button337_mouseIn(event) {
    $w("#box44").show(); 
}

export function button337_mouseOut(event) {
    $w("#box44").hide();  
}

export function button336_mouseIn(event) {
    $w("#box44").show(); 
}

export function button336_mouseOut(event) {
    $w("#box44").hide();  
}

export function button335_mouseIn(event) {
    $w("#box44").show(); 
}

export function button335_mouseOut(event) {
    $w("#box44").hide();  
}

export function button341_mouseIn(event) {
    $w("#box45").show();  
}

export function button341_mouseOut(event) {
    $w("#box45").hide(); 
}

export function button340_mouseIn(event) {
    $w("#box45").show();  
}

export function button340_mouseOut(event) {
    $w("#box45").hide(); 
}

export function button374_mouseIn(event) {
    $w("#box46").show(); 
}

export function button374_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button345_mouseIn(event) {
    $w("#box46").show();  
}

export function button345_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button344_mouseIn(event) {
    $w("#box46").show(); 
}

export function button344_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button375_mouseIn(event) {
    $w("#box46").show(); 
}

export function button375_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button342_mouseIn(event) {
    $w("#box46").show(); 
}

export function button342_mouseOut(event) {
    $w("#box46").hide(); 
}

export function button354_mouseIn(event) {
    $w("#box47").show(); 
}

export function button354_mouseOut(event) {
    $w("#box47").hide();  
}

export function button353_mouseIn(event) {
    $w("#box47").show(); 
}

export function button353_mouseOut(event) {
    $w("#box47").hide();  
}

export function button352_mouseIn(event) {
    $w("#box47").show(); 
}

export function button352_mouseOut(event) {
    $w("#box47").hide();  
}

export function button351_mouseIn(event) {
    $w("#box47").show(); 
}

export function button351_mouseOut(event) {
    $w("#box47").hide();  
}

export function button350_mouseIn(event) {
    $w("#box47").show(); 
}

export function button350_mouseOut(event) {
    $w("#box47").hide();  
}

export function button349_mouseIn(event) {
    $w("#box47").show(); 
}

export function button349_mouseOut(event) {
    $w("#box47").hide();  
}

export function button348_mouseIn(event) {
    $w("#box47").show(); 
}

export function button348_mouseOut(event) {
    $w("#box47").hide();  
}

export function button347_mouseIn(event) {
    $w("#box47").show(); 
}

export function button347_mouseOut(event) {
    $w("#box47").hide();  
}

export function button359_mouseIn(event) {
    $w("#box48").show(); 
}

export function button359_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button358_mouseIn(event) {
    $w("#box48").show(); 
}

export function button358_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button357_mouseIn(event) {
    $w("#box48").show(); 
}

export function button357_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button356_mouseIn(event) {
    $w("#box48").show(); 
}

export function button356_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button355_mouseIn(event) {
    $w("#box48").show(); 
}

export function button355_mouseOut(event) {
     $w("#box48").hide(); 
}

export function button365_mouseIn(event) {
    $w("#box49").show(); 
}

export function button365_mouseOut(event) {
    $w("#box49").hide();
}

export function button364_mouseIn(event) {
    $w("#box49").show(); 
}

export function button364_mouseOut(event) {
    $w("#box49").hide();
}

export function button363_mouseIn(event) {
    $w("#box49").show(); 
}

export function button363_mouseOut(event) {
    $w("#box49").hide();
}

export function button362_mouseIn(event) {
    $w("#box49").show(); 
}

export function button362_mouseOut(event) {
    $w("#box49").hide();
}

export function button361_mouseIn(event) {
    $w("#box49").show(); 
}

export function button361_mouseOut(event) {
    $w("#box49").hide();
}

export function button360_mouseIn(event) {
    $w("#box49").show(); 
}

export function button360_mouseOut(event) {
    $w("#box49").hide();
}

export function button367_mouseIn(event) {
    $w("#box50").show(); 
}

export function button367_mouseOut(event) {
    $w("#box50").hide(); 
}

export function button366_mouseIn(event) {
    $w("#box50").show(); 
}

export function button366_mouseOut(event) {
    $w("#box50").hide(); 
}



/**
*	Adds an event handler that runs when the mouse pointer is moved
 onto the element.

> **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function button377_mouseIn(event) {
    $w("#box47").show(); 
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 off of the element.

 > **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/tips-tutorials-examples/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function button377_mouseOut(event) {
    $w("#box47").hide();  
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 onto the element.

> **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/wix-tips-and-updates/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function button378_mouseIn(event) {
    $w("#box46").show();   
}

/**
*	Adds an event handler that runs when the mouse pointer is moved
 off of the element.

 > **Deprecation note:** The $w parameter of event handlers is being deprecated. To get
 a scoped selector for working with elements in repeater items, use the [$w.at()]($w.html#at) function
 and pass it the context property of the event parameter: `$item = $w.at(event.context)`. To learn more, see
 [here](https://www.wix.com/velo/forum/tips-tutorials-examples/removal-of-the-w-parameter-from-event-handlers).

 You can also [define an event handler using the Properties and Events panel](https://support.wix.com/en/article/velo-reacting-to-user-actions-using-events).
*	 @param {$w.MouseEvent} event
*/
export function button378_mouseOut(event) {
    $w("#box46").hide();  
}